export default {
  common: {
    read_bio: 'Lire la bio',
  },
};
